module.exports = __webpack_public_path__ + "static/img/constractor_logo4.cf2a7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/constractor_logo4.png
// module id = cOwl
// module chunks = 159